import { useEffect, useRef } from "react";

function useEffectJustChanges(
  callback: () => void,
  dependencies?: Array<unknown>
) {
  const reference = useRef(false);

  useEffect(() => {
    if (reference.current) {
      return callback?.();
    }
    reference.current = true;
  }, dependencies || []);
}

export default useEffectJustChanges;
